import React, { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const REACT_APP_API = process.env.REACT_APP_API_BASE_URL;

const ResetPassword = () => {
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const code = searchParams.get("code");
    const email = searchParams.get("email");

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [error2, setError2] = useState("");
    const [message, setMessage] = useState("");
    const passwordRef = useRef(null);
    const confirmPasswordRef = useRef(null);

    const handleResetPassword = async (e) => {
        e.preventDefault();

        setError("");
        setError2("");
        setMessage("");

        if (!email || !code) {
            setMessage("Invalid or expired password reset link.");
            return;
        }
        if (!password.trim()) {
            setError("Please enter Password.");
            passwordRef.current?.focus();
            return;
        }
        if (!confirmPassword.trim()) {
            setError2("Please enter Confirm Password.");
            confirmPasswordRef.current?.focus();
            return;
        }
        if (confirmPassword !== password) {
            setMessage("Password and Confirm Password do not match.");
            confirmPasswordRef.current?.focus();
            return;
        }

        setLoading(true);

        try {
            const params = {
                email: email,
                password: password,
                confirmPassword: confirmPassword,
                code: code,
            };
            const res = await axios.post(`${REACT_APP_API}/api/Account/ResetPassword`, params);
            console.log("res", res)
            if (res.status === 200) {
                alert(res.data.message);
                navigate("/login");
            } else {
                alert(res.message);
                navigate("/forgot-password");
            }
        } catch (err) {
            setError("Invalid username or password");
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <div id="kt_body" class="auth-bg">
                <div class="d-flex flex-column flex-root">
                    <div class="d-flex flex-column flex-column-fluid flex-lg-row">

                        <div class="d-flex flex-center w-lg-50 pt-15 pt-lg-0 px-10">

                            <div class="d-flex flex-center flex-lg-start flex-column mobile-none">

                                <a href="/" class="mb-7">
                                    <img src="/assets/images/logo.png" alt="img" className='logo_login' />
                                </a>
                                <h2 class="text-white fw-normal m-0">Travel Management System</h2>

                            </div>
                        </div>
                        <div class="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12">
                            <div class="bg-body d-flex flex-column align-items-stretch flex-center rounded-4 w-md-500px p-10">
                                <div class="d-flex flex-center flex-column flex-column-fluid px-lg-0">
                                    <form class="form w-100" onSubmit={handleResetPassword}>
                                        <div class="text-center mb-15 mt-5">
                                            <img src="/assets/images/logo.png" alt="img" className='logo_login desk-none' />
                                            <h1 class="text-gray-900 fw-bolder mb-3 mobile-none">Reset Password</h1>
                                        </div>
                                        {message && <p className="text-danger text-center">{message}</p>}
                                        <div class="fv-row mb-3">
                                            <input
                                                ref={passwordRef}
                                                type="password"
                                                placeholder="Password"
                                                className="form-control bg-transparent"
                                                value={password}
                                                onChange={(e) => {setPassword(e.target.value); setError("");}}
                                            />
                                        {error && <p className="text-danger">{error}</p>}
                                        </div>
                                        <div class="fv-row mb-3">
                                            <input
                                                ref={confirmPasswordRef}
                                                type="password"
                                                placeholder="Confirm Password"
                                                className="form-control bg-transparent"
                                                value={confirmPassword}
                                                onChange={(e) => {setConfirmPassword(e.target.value); setError2("");}}
                                            />
                                        </div>
                                        {error2 && <p className="text-danger">{error2}</p>}
                                        <div class="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
                                            <div></div>

                                        </div>
                                        <div class="d-grid mb-10">
                                            <button type="submit" className="btn btn-primary">
                                                <span className="indicator-label">Reset Password</span>
                                                {loading && (
                                                    <p class="text-center load"><span class="loader"></span></p>
                                                )}
                                            </button>
                                        </div>
                                        <div class="text-gray-500 text-center fw-semibold fs-6">Already have an account?
                                            <a href="/login" class="link-primary">Sign in</a></div>
                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}
export default ResetPassword;
